import Vue from 'vue'
const requests = {
  infrastructure: null,
  borders: null
}

export default {
  getInfrastructureLayer({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.infrastructure, {
        params: {
          limit: 2000,
          offset: 0,
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(',')
        }
      })
      .then((r) => {
        const objects = r.body.results.map((v) => {
          return {
            ...v,
            name: v.name || 'Объект №' + v.id,
            technologies: v.technologies.map((technology) => {
              return {
                ...technology,
                name: technology.name || 'Технология ' + technology.id
              }
            })
          }
        })
        commit('setTechInfrastructure', objects)
      })
  },
  getInfrastructureTechnologyMap({ commit, getters, dispatch }) {
    const requestParams = {
      workspace: getters.workspace,
      version: getters.version
    }
    commit('setTechLoadingData', 1)
    return Vue.http
      .get(getters.endpoint.map.infrastructure, {
        params: requestParams,
        before(request) {
          dispatch('abortTechMapRequest', { request, key: 'infrastructure' })
        }
      })
      .then((r) => {
        requests.infrastructure = null
        commit('updateTechMapData', {
          infrastructure: r.body
        })
        commit('setTechLoadingData', 0)
      })
      .catch((e) => {
        commit('setTechLoadingData', 0)
        dispatch('handleTechMapErros', e)
      })
  },
  getInfrastructureTechnologyBorders({ commit, getters, dispatch }) {
    if (getters.techMapParams) {
      commit('setTechLoadingData', 1)
      Vue.http
        .get(getters.endpoint.map.admterritory, {
          params: {
            zoom: getters.techMapParams.zoom,
            square: getters.techMapParams.square,
            workspace: getters.workspace,
            version: getters.version,
            adm_level: 20
          },
          before(request) {
            dispatch('abortTechMapRequest', { request, key: 'borders' })
          }
        })
        .then((r) => {
          requests.borders = null
          commit('updateTechMapData', {
            borders: r.body
          })
          commit('setTechLoadingData', 0)
        })
        .catch((e) => {
          commit('setTechLoadingData', 0)
          dispatch('handleTechMapErros', e)
        })
    }
  },
  getExcelFiles({ commit, getters }, infrastructureId) {
    return Vue.http
      .get(getters.endpoint.excelFiles, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          infrastructure: infrastructureId
        }
      })
      .then((r) => {
        commit('setTechExcelFiles', r.body)
      })
  },
  getExcelFile({ getters, commit }, params) {
    let requestParams = {
      workspace: getters.workspace,
      version: getters.version,
      infrastructure: params.infrastructure
    }

    //Если отображение выбора периода отключено, то не отправляем параметр с периодом так как он не нужен
    if (params.period) {
      requestParams.period = params.period
    }

    return Vue.http
      .get(getters.endpoint.excelFile(params.type, params.id), {
        responseType: 'blob',
        params: requestParams
      })
      .then((r) => {
        return r.data
      })
  },
  recalculateExcelFile({ commit, getters }, params) {
    return Vue.http
      .post(getters.endpoint.excelFile(params.type, params.id) + '/', params.userValues, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          period: params.period,
          infrastructure: params.infrastructure
        }
      })
      .then((r) => {
        return r.body
      })
  },

  abortTechMapRequest({}, params) {
    if (requests[params.key]) {
      requests[params.key].abort()
    }
    requests[params.key] = params.request
  },
  handleTechMapErros({}, e) {
    if (e.status === 0) {
      return
    }
    throw e
  }
}



// WEBPACK FOOTER //
// ./src/store/technologies/actions.js